export type ContentType =
  | "article"
  | "articleheader"
  | "audiotrack"
  | "biography"
  | "bundle"
  | "collection"
  | "externallink"
  | "infographic"
  | "interactivevideolink"
  | "LEGACY_ARTICLE"
  | "lessonspark"
  | "poll"
  | "standard"
  | "textset"
  | "video"
  | "worksheet"
  | "ARTICLE"
  | "BUNDLE"
  | "INTERACTIVE_VIDEO"
  | "GENERATION_GENIUS_VIDEO"
  | "PHET_SIMULATION"
  | "TUVA_DATASET";

const getContentLabel = (props: {
  content_type: ContentType;
  label: string;
}): string => {
  const contentLabelMap = {
    article: "Article",
    articleheader: "Article",
    audiotrack: "Audio",
    biography: "Biography",
    bundle: "Bundle",
    collection: "Collection",
    externallink: props?.label,
    infographic: "Infographic",
    interactivevideolink: "Interactive Video",
    LEGACY_ARTICLE: "Article",
    lessonspark: "Lesson Spark",
    poll: "Poll",
    standard: "Standard",
    textset: props?.label || "Text Set",
    video: "Video",
    worksheet: "Worksheet",
    ARTICLE: "Article",
    BUNDLE: "Bundle",
    INTERACTIVE_VIDEO: "Video",
    GENERATION_GENIUS_VIDEO: "Video",
    PHET_SIMULATION: "PhET Simulation",
    TUVA_DATASET: "Tuva Dataset",
  };

  return contentLabelMap[props?.content_type];
};

export default getContentLabel;
